module.exports = __webpack_public_path__ + "img/logo.bb6ab1f0.png";